import React from 'react';

function SectionHeader({ label, title, description, align = 'center', className = '' }) {
  const classes = ['section-head', align === 'left' ? 'left' : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes}>
      {label && <div className="section-label">{label}</div>}
      {title && <h2>{title}</h2>}
      {description && <p className="section-sub">{description}</p>}
    </div>
  );
}

export default SectionHeader;
